import { render } from "./Footer.vue?vue&type=template&id=05bbc917"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=05bbc917&lang=scss"
script.render = render

export default script